// extracted by mini-css-extract-plugin
module.exports = {"Input":"Radio_Input__mWvXo","mark":"Radio_mark__oL8Vq"};